import "./EmptyState.scss";

import { Notice } from "@appkit4/react-components/notification";
import type { ReactNode } from "react";

export interface EmptyStateProps {
  /** Optional icon or illustration */
  icon?: ReactNode;
  /** Main message (e.g. "No items yet") */
  title: string;
  /** Optional description */
  description?: string;
  /** Optional primary action */
  action?: ReactNode;
}

const EMPTY_STATE_TITLE_ID = "shared-empty-state-title";

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="shared-empty-state" role="status" aria-labelledby={EMPTY_STATE_TITLE_ID}>
      <Notice
        className="shared-empty-state__notice"
        title={title}
        message={description ?? ""}
        icon={icon}
        closeable={false}
      />
      <span id={EMPTY_STATE_TITLE_ID} className="shared-empty-state__sr-only">
        {title}
      </span>
      {action != null && (
        <div className="shared-empty-state__action">
          {action}
        </div>
      )}
    </div>
  );
}
